module.exports = __webpack_public_path__ + "img/part_6_5.dbdd291e.webp";